const productGroupFields = `
    slug,
    shopifyProducts[] {
        productColour -> {
            ...,
        },
        productReferenceV2 -> {
            ...,
        }
    },
`;

export default productGroupFields;
